import Invoice from '@/services/invoice'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const fetchExampleInvoiceRequest = async ({ commit }, obj) => {
  return new Promise((resolve, reject) => {
    Invoice.exampleInvoiceRequest().then((response) => {
      commit('SET_EXAMPLE', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const save = (context, payload) => {
  return new Promise((resolve, reject) => {
    Invoice.saveInvoiceRequest(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

export default {
  fetchExampleInvoiceRequest,
  save
}



// WEBPACK FOOTER //
// ./src/features/invoice_requests/store/actions.js